import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService extends ApiService {

  constructor(http: HttpClient) {
    super(`${environment.apiUrl}`, http);
  }

  getUsers(role) {
    return this.getUrl('/user?role='+role)
  }
}
